import { TRoomsParams } from 'common/types/floor-params.type';
import { atom } from 'recoil';

export const defaultRoomParams = {
  createdDate: '',
  calculatorId: '',
} as TRoomsParams;

export const roomArea = atom({
  key: 'roomArea',
  default: false,
});

export const doorsWindowsArea = atom({
  key: 'doorsWindowsArea',
  default: true,
});

export const calculatedRoomsParams = atom({
  key: 'calculatedRoomParams',
  default: defaultRoomParams,
});

export const activeRoomId = atom({
  key: 'selectedRoomId',
  default: '',
});
